module.exports = __webpack_public_path__ + "img/2019.f8bcae2d.png";